import React from 'react';
import styled from 'styled-components';
import EventDetail from "./EventDetail";
import UserList from "./UserList";

const PopupCard = ({ session }) => {
    const { title, contributors, startTime, endTime, files, isCrossDate, prLink, prMeta, googleDocs, figmaFiles } = session;
    return (
        <StyledCard>
            <CardTitle>{title}</CardTitle>
            <UserList contributors={contributors} />
            <EventDetail
                startTime={startTime}
                endTime={endTime}
                isCrossDate={isCrossDate}
                files={files}
                prLink={prLink}
                prMeta={prMeta}
                googleDocs={googleDocs}
                figmaFiles={figmaFiles}
            />
        </StyledCard>
    );
};

const StyledCard = styled.article`
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  padding: 4px;
  margin-bottom: 8px;

  flex-direction: column;
  border: 1px solid #9333ea;
  color: #969a97;
    
`;

const CardTitle = styled.h2`
    color: #000;
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 23px;
    text-align: left;
    margin: 0 0 10px 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export default PopupCard;